export const data =  {
    "Items": [
        {
            "id": 656444,
            "title": "Plum Cake",
            "image": "https://spoonacular.com/recipeImages/656444-312x231.jpg",
            "price": 390
        },
        {
            "id": 650601,
            "title": "Madeleines",
            "image": "https://spoonacular.com/recipeImages/650601-312x231.jpg",
            "price": 250
        },
        {
            "id": 633419,
            "title": "Baked Apple",
            "image": "https://spoonacular.com/recipeImages/633419-312x231.jpg",
            "price": 180
        },
        {
            "id": 64694,
            "title": "Gingerbread",
            "image": "https://spoonacular.com/recipeImages/64694-312x231.jpg",
            "price": 200
        },
        {
            "id": 634006,
            "title": "Banana Bread",
            "image": "https://spoonacular.com/recipeImages/634006-312x231.jpg",
            "price": 410
        },
        {
            "id": 658276,
            "title": "Rice Pudding",
            "image": "https://spoonacular.com/recipeImages/658276-312x231.jpg",
            "price": 360
        },
        {
            "id": 658193,
            "title": "Rhubarb Crisp",
            "image": "https://spoonacular.com/recipeImages/658193-312x231.jpg",
            "price": 240
        },
        {
            "id": 662151,
            "title": "Sugar Cookies",
            "image": "https://spoonacular.com/recipeImages/662151-312x231.jpg",
            "price": 440
        }
    ]
}